import type { ReactNode } from 'react';
import { BottomSheet } from '@/shared/components';

interface Props {
  /** Ab `lg` läuft die Akte dreispaltig — dort ist die Pane eine echte Spalte. */
  desktop: boolean;
  /** Zugänglicher Name des Sheets; die Pane bringt ihre eigene sichtbare Überschrift mit. */
  title: string;
  /** Was das Sheet zeigt — Radix verlangt eine Beschreibung, sonst warnt es zur Laufzeit. */
  description: string;
  onClose: () => void;
  children: ReactNode;
}

/**
 * Hülle der Detail-/Auswahl-Pane: rechte Spalte auf Desktop, Bottom-Sheet darunter.
 *
 * FRONTEND_GUIDELINES §8. Vorher war die Pane auch mobil eine dritte gestapelte Spalte und
 * landete damit unter der kompletten Dateiliste — sichtbar nur, wenn man an allem vorbeiscrollt.
 */
export function AkteDetailHost({ desktop, title, description, onClose, children }: Props) {
  if (desktop) {
    return (
      <aside
        aria-label={title}
        className="border-line bg-card/40 lg:w-90 flex w-full flex-col rounded-lg border lg:sticky lg:top-4 lg:max-h-[calc(var(--shell-viewport,100dvh)-6rem)] lg:shrink-0 lg:overflow-y-auto"
      >
        {children}
      </aside>
    );
  }
  return (
    <BottomSheet
      open
      onOpenChange={(v) => !v && onClose()}
      title={title}
      description={description}
      className="max-h-[92dvh]"
      bare
    >
      {children}
    </BottomSheet>
  );
}
